module.exports = __webpack_public_path__ + "static/media/testimonials-woman.7973aa50.svg";